import axios from 'axios';
import { API_HOST } from '../../env';

export default class ApiBase {
  static objectToQueryString(obj) {
    if (!obj) {
      return null;
    }

    const queryArray = Object.keys(obj).map(key =>
      `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);

    return queryArray.join('&');
  }

  static client(headers) {
    return axios.create({
      baseURL: `${API_HOST}/api/`,
      timeout: 3000,
      headers,
    });
  }

  static async post(url, params, headers = {}) {
    try {
      return (await ApiBase.client(headers).post(url, params));
    } catch (error) {
      throw error;
    }
  }

  static async put(url, params, headers = {}) {
    try {
      return (await ApiBase.client(headers).put(url, params));
    } catch (error) {
      throw error;
    }
  }

  static async get(url, params = {}, headers = {}) {
    const searchParams = ApiBase.objectToQueryString(params);
    const urlWithParams = searchParams ? `${url}?${searchParams}` : url;
    try {
      return (await ApiBase.client(headers).get(urlWithParams));
    } catch (error) {
      throw error;
    }
  }
}
